"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFiniteNumber = isFiniteNumber;

var _isFinite2 = _interopRequireDefault(require("lodash/isFinite"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NUMERIC_RE = /^[0-9]+$/;
/**
 * Checks if the input value is a finite number. This function differs from the
 * lodash utilities _.isNumber and _.isFinite in that it will return true for
 * both string and number values.
 *
 * @param {*} value - Value to check.
 * @returns {boolean} - true if the value is a number
 */

function isFiniteNumber(value) {
  return NUMERIC_RE.test(value) && (0, _isFinite2.default)(parseInt(value, 10));
}